import { useState, useCallback } from 'react';

/**
 * Custom hook for managing snackbar notifications
 * Provides a centralized way to show success/error/info messages
 */
export const useNotification = () => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success' // 'success', 'error', 'warning', 'info'
  });

  const showNotification = useCallback((message, severity = 'success') => {
    setSnackbar({
      open: true,
      message,
      severity
    });
  }, []);

  const hideNotification = useCallback(() => {
    setSnackbar(prev => ({
      ...prev,
      open: false
    }));
  }, []);

  return {
    snackbar,
    showNotification,
    hideNotification
  };
};
